import {
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonPage,
  useIonAlert,
} from '@ionic/react';
import React from 'react';
import useEnhancedAuth, { useCookieAuth } from '../EnhancedAuth';
import './Default.css';
import getDeviceIdCookie from '../DeviceIdCookie';
import getBundleIdCookie from '../BundleIdCookie';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { returnToMainLogout } from '../utils/nav';
import Cookies from 'js-cookie';

const Home: React.FC = () => {
  const auth = useEnhancedAuth();
  const router = useHistory();
  const [presentAlert, dismissAlert] = useIonAlert();
  const [showLoading, setShowLoading] = React.useState(false);
  const [t, i18n] = useTranslation('global');

  const handleLoginDialog = (useCooke: boolean) => {
    presentAlert({
      header: 'Login',
      inputs: [
        {
          name: 'username',
          type: 'text',
          placeholder: 'Username',
          value: 'jannik.stoewing.hc+metrodev@gmail.com',
        },
        {
          name: 'password',
          type: 'password',
          placeholder: 'Password',
          value: 'Test1234!',
        },
      ],
      buttons: [
        { text: 'Cancel', role: 'cancel', handler: dismissAlert },
        {
          text: 'Login',
          handler: (formValues) => {
            authenticateUser(
              formValues.username,
              formValues.password,
              useCooke,
            );
          },
        },
      ],
    });
  };

  const migrateVirtualCard = async () => {
    try {
      setShowLoading(true);
      const response = await fetch(
        process.env.REACT_APP_API_BASE + 'v2/users/fare-medias/virtual-card',
        {
          method: 'PUT',
          headers: {
            Authorization: `Bearer ${auth.user?.access_token}`,
            appId: 'metro',
            deviceId: getDeviceIdCookie().device_id,
            bundleId: getBundleIdCookie(),
          },
        },
      );

      if (response.ok) {
        presentAlert('Card successfully migrated to your device.');
      } else {
        throw new Error('Failed to migrate card.');
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        presentAlert(`Migration Error: ${error.message}`);
      } else {
        presentAlert('Migration Error: An unknown error occurred.');
      }
    } finally {
      setShowLoading(false);
    }
  };

  const logout = () => {
    auth.logout();
    returnToMainLogout(router);
  };

  const authenticateUser = async (
    username: string,
    password: string,
    useCooke: boolean,
  ) => {
    try {
      setShowLoading(true);
      const clientSecret = process.env.REACT_APP_CLIENT_SECRET || '';
      const authenticationUrl =
        process.env.REACT_APP_DEBUG_AUTH_PROXY_URL ||
        process.env.REACT_APP_API_BASE +
          'realms/metro/protocol/openid-connect/token';
      const response = await fetch(
        authenticationUrl,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            appId: 'metro',
          },
          body: `grant_type=password&username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&client_secret=${encodeURIComponent(clientSecret)}&client_id=metro_app1`,
        },
      );

      const authRes = await response.json();

      //authRes = JSON.parse('{"access_token":"eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJKNV9lNjdyV3p4dmN1UTV2dVBHZWxJNVJuYXltdUM0MXZENXpzZnZ0MkZzIn0.eyJleHAiOjE3ODM2OTExOTcsImlhdCI6MTc4MzY5MDg5NywianRpIjoib25ydHJvOjY4NjQ1YTlkLWI3OWMtMzMzYS1hMjE0LTllMmMzM2IwZGMwOSIsImlzcyI6Imh0dHBzOi8vYWNjb3VudHMuY2kubXZ0aWNrZXRpbmcuY29tL3JlYWxtcy9tZXRybyIsInN1YiI6ImY6YzUzMzQ5YTEtYWU2MC00NGU0LWEzYjgtZGVlNDFhMzRmNWZiOjIwNDgiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJtZXRyb19hcHAxIiwic2lkIjoiWlhybE40Ni1maHJJd3hncVFEb0pnTW91IiwiYWNyIjoiMSIsInNjb3BlIjoiZW1haWwgcHJvZmlsZSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJwcm9maWxlIjp7ImdpdmVuX25hbWUiOiJKYW5uaWsiLCJmYW1pbHlfbmFtZSI6IlN0b2V3aW5nIn0sIm5hbWUiOiJKYW5uaWsgU3RvZXdpbmciLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJqYW5uaWsuc3RvZXdpbmcuaGMrbWV0cm9kZXZAZ21haWwuY29tIn0.nv9rX4Yivi3xBXRpVEjJo6jS74THz5O3D_1-Ws8KmzWZ0sSu1FsM96fsajLE7kf9N1S-9GWtXaiw7FmQVvZbTIFMIxvndlfLXWj4A_kwJ-A_bh9mMBiB9ashNDTAXFYrc831yN_W-CvxqBH3GD86aPwuR01yyWOhJc1ejosRipuZS_AUI6qAz4GPLkzq_1Gfyq9YdEHHmv8gbvgBcqEcRgEUjdqr-S8uulw52SdZvtvvcnNqW8Wen75NWEWsheOUbLBFN4Dt3QyOFyRmWQy3ntqd0yRLCxXaFHM3T_cxHt6y4G8i_CA_LMv8Mk_D7z3ww80S6_nSAmLc4Zvl55DSAA","expires_in":300,"refresh_expires_in":2592000,"refresh_token":"eyJhbGciOiJIUzUxMiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJhMWQ4YmRjMC0xMmI5LTQ3MmItYThlNC1kMjE4ZGM4MTRkY2MifQ.eyJleHAiOjE3ODYyODI4OTcsImlhdCI6MTc4MzY5MDg5NywianRpIjoiNTgzM2ZmY2YtYjE0MC1lZDgxLWJlYjYtYWYyMGUyZWRjMTVjIiwiaXNzIjoiaHR0cHM6Ly9hY2NvdW50cy5jaS5tdnRpY2tldGluZy5jb20vcmVhbG1zL21ldHJvIiwiYXVkIjoiaHR0cHM6Ly9hY2NvdW50cy5jaS5tdnRpY2tldGluZy5jb20vcmVhbG1zL21ldHJvIiwic3ViIjoiZjpjNTMzNDlhMS1hZTYwLTQ0ZTQtYTNiOC1kZWU0MWEzNGY1ZmI6MjA0OCIsInR5cCI6IlJlZnJlc2giLCJhenAiOiJtZXRyb19hcHAxIiwic2lkIjoiWlhybE40Ni1maHJJd3hncVFEb0pnTW91Iiwic2NvcGUiOiJlbWFpbCBhY3IgcHJvZmlsZSBiYXNpYyB3ZWItb3JpZ2lucyByb2xlcyIsInJldXNlX2lkIjoiNTk3NzExNTctYmIyNi00MjA5LTkyYjctOTk2NDMyYjlhYTdhIn0.cHY4EHiyRksOpbiF-nw-z7z1mUdraKsjS2qTzMziaRVT5kxsIzWJj0oqIzJuPUFRBNQVdaWEu9cqLX8BinCLvQ","token_type":"Bearer","not-before-policy":0,"session_state":"ZXrlN46-fhrIwxgqQDoJgMou","scope":"email profile"}')
      if (response.ok && authRes.access_token) {
        router.push('/cards');
        if (useCooke) {
          Cookies.set(
            'auth',
            `${authRes.access_token};${authRes.refresh_token}`,
            { expires: 365 },
          );
          window.location.reload();
        } else {
          window.postMessage(
            `auth=${authRes.access_token};${authRes.refresh_token}`,
          );
        }
        //presentAlert(`Logged in! Token: ${authRes.access_token}`);
        //window.location.reload();
      } else {
        throw new Error(authRes.error || 'Failed to login.');
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        presentAlert(`Authentication Error: ${error.message}`);
      } else {
        presentAlert(`Authentication Error: An unknown error occurred.`);
      }
    } finally {
      setShowLoading(false);
    }
  };

  return (
    <IonPage id="home-page" className="home-page-ios">
      <IonContent fullscreen className="home-page-ios">
        <IonLoading isOpen={showLoading} message={'Please wait...'} />
        <IonList className="home-page-ios">
          {auth.isAuthenticated
            ? [
                <IonListHeader
                  key={Math.random().toString()}
                  lines="inset"
                  className="home-page-ios"
                >
                  <IonLabel>{t('home.select')}</IonLabel>
                </IonListHeader>,
                <IonItem
                  key={Math.random().toString()}
                  lines="full"
                  button
                  onClick={() => router.push('account')}
                >
                  <IonLabel>{t('home.account')}</IonLabel>
                </IonItem>,
                <IonItem
                  key={Math.random().toString()}
                  lines="full"
                  button
                  onClick={() => router.push('accountpassword')}
                >
                  <IonLabel>{t('home.changepw')}</IonLabel>
                </IonItem>,
                <IonItem
                  key={Math.random().toString()}
                  lines="full"
                  button
                  onClick={() => router.push('accountquestions')}
                >
                  <IonLabel>{t('home.questions')}</IonLabel>
                </IonItem>,
                <IonItem
                  key={Math.random().toString()}
                  lines="full"
                  button
                  onClick={() => router.push('payments')}
                >
                  <IonLabel>{t('home.payments')}</IonLabel>
                </IonItem>,
                <IonItem
                  key={Math.random().toString()}
                  lines="full"
                  button
                  onClick={() => router.push('cards')}
                >
                  <IonLabel>{t('home.farecards')}</IonLabel>
                </IonItem>,
                <IonItem
                  key={Math.random().toString()}
                  lines="full"
                  button
                  onClick={migrateVirtualCard}
                >
                  <IonLabel>Migrate Virtual Card</IonLabel>
                </IonItem>,
                <IonItem
                  key={Math.random().toString()}
                  lines="full"
                  button
                  onClick={() => router.push('feedback')}
                >
                  <IonLabel>{t('home.feedback')}</IonLabel>
                </IonItem>,
                <IonItem
                  key={Math.random().toString()}
                  lines="full"
                  button
                  onClick={() => router.push('unregister')}
                >
                  <IonLabel>{t('home.unregister')}</IonLabel>
                </IonItem>,
              ]
            : []}

          <IonListHeader lines="inset" className="home-page-ios">
            <IonLabel>Authentication</IonLabel>
          </IonListHeader>

          {auth.isAuthenticated
            ? [
                <IonItem
                  key={Math.random().toString()}
                  lines="full"
                  button
                  onClick={() => logout()}
                >
                  <IonLabel>Logout</IonLabel>
                </IonItem>,
                <IonItem
                  key={Math.random().toString()}
                  lines="full"
                  button
                  onClick={() => console.log(auth)}
                >
                  <IonLabel>Dump Authentication to console</IonLabel>
                </IonItem>,
              ]
            : [
                <IonItem
                  key={Math.random().toString()}
                  lines="full"
                  button
                  onClick={() => router.push('register-user')}
                >
                  <IonLabel>Register User</IonLabel>
                </IonItem>,
                <IonItem
                  key={Math.random().toString()}
                  lines="full"
                  button
                  onClick={() => router.push('password-reset')}
                >
                  <IonLabel>Reset Password</IonLabel>
                </IonItem>,
              ]}
        </IonList>
        <IonList>
          <IonListHeader lines="inset" className="home-page-ios">
            <IonLabel>Debug</IonLabel>
          </IonListHeader>
          {useCookieAuth() ? (
            <IonItem
              key={Math.random().toString()}
              lines="full"
              button
              onClick={() => handleLoginDialog(true)}
            >
              <IonLabel>Simulate Login with Cookie</IonLabel>
            </IonItem>
          ) : (
            <IonItem
              key={Math.random().toString()}
              lines="full"
              button
              onClick={() => handleLoginDialog(false)}
            >
              <IonLabel>Simulate Login with PostMessage</IonLabel>
            </IonItem>
          )}
        </IonList>
        <div className="copyright">
          <br />
          &copy; HanseCom {new Date().getFullYear()}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Home;
